import(/* webpackMode: "eager" */ "/home/runner/work/Seedmancer-web/Seedmancer-web/next/src/app/page.tsx");
